var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcTagBlock = function SvgIcTagBlock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M20.278 11.137 13.382 4.24a.728.728 0 0 0-.561-.24H4.8c-.478 0-.8.32-.8.802v8.019c0 .24.08.4.24.561l6.897 6.896c.48.481 1.042.722 1.684.722.641 0 1.283-.24 1.684-.722l5.773-5.773c.963-.963.963-2.406 0-3.368zm-1.122 2.245-5.774 5.774a.775.775 0 0 1-1.123 0L5.604 12.5V5.604H12.5l6.656 6.655c.32.321.32.802 0 1.123zM9.373 8.25c.16.16.24.32.24.561 0 .24-.08.401-.24.562a.729.729 0 0 1-.562.24.73.73 0 0 1-.561-.24c-.08-.08-.16-.16-.16-.24-.08-.081-.08-.241-.08-.322 0-.24.08-.4.24-.561.24-.24.561-.32.882-.16.08 0 .16.08.24.16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#364355",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcTagBlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-tag-block.731cf6bf1c6d0d7f34ca95dd979e0f9f.svg";